export const dashboardEntry = {
  key: 'surface-landing',
  title: 'Surface overview',
  description: 'How big your estate is, what is exposed, where coverage is missing, and what to fix first.',
  route: '/surface',
  // Lucide icon name in kebab-case; the hub maps it to a component.
  icon: 'gauge',
  apps: ['surface'],
  // The API serves owners and admins only, like the inventory it summarizes.
  adminOnly: true,
  // The overview's read sits behind this flag; without it /surface shows findings.
  flag: 'surface.uamReads',
} as const;
